import React from "react"
import { Field, ErrorMessage, getIn } from "formik"

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <fieldset className="fieldset">
        <legend>توضیحات</legend>

        <Field name="description" rows="2"
          render={({ field }) =>
            <textarea {...field}
              value={values.description || ''}
              className="textarea rtl"
            />}
        />

      </fieldset>

    </div>

  </div>
);